/* Fiche à re-confirmer — DS-05 (Bible §19/§56 · ADM-09).
   A listing mismatch pauses trust, not the journey: reporting is labelled
   « à vérifier » and never shown as invented zeros, while gifts, Mes cadeaux
   and redemption carry on untouched. */
import { Button, Card, EmptyState, ErrorState, Note } from '@/ui'
import { useGoogle } from './api'
import { Chargement, Retour } from './parts'

export default function Fiche() {
  const { data, isPending, isError, refetch } = useGoogle()

  if (isPending) return <Chargement />
  if (isError) return (
    <ErrorState what="Impossible de comparer votre fiche."
      action={<Button variant="primary" size="sm" onClick={() => refetch()}>Réessayer</Button>} />
  )

  const drift = data.drift
  if (!drift) return (
    <div style={{ display: 'grid', gap: 16, maxWidth: 620 }}>
      <Retour />
      <EmptyState title="Aucune fiche à re-confirmer."
        why="Les fiches liées correspondent à ce qui est publié aujourd’hui. Si l’une d’elles change de nom ou d’adresse, elle apparaîtra ici." />
    </div>
  )

  return (
    <div style={{ display: 'grid', gap: 16, maxWidth: 640 }}>
      <Retour />
      <h2 className="t-page" style={{ margin: 0 }}>Fiche à re-confirmer</h2>

      <Note tone="candour">
        <b>⚠ La fiche Google liée à «&nbsp;{drift.location}&nbsp;» semble avoir changé (nom ou adresse).</b>
      </Note>

      <div style={{ display: 'grid', gap: 10, gridTemplateColumns: '1fr 1fr' }}>
        <Card>
          <p className="t-card" style={{ margin: 0 }}>Enregistré</p>
          <p className="f-help" style={{ marginTop: 4 }}>{drift.stored.name}<br />{drift.stored.address}</p>
        </Card>
        <Card>
          <p className="t-card" style={{ margin: 0 }}>Sur Google aujourd’hui</p>
          <p className="f-help" style={{ marginTop: 4 }}>{drift.live.name}<br />{drift.live.address}</p>
        </Card>
      </div>

      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
        <Button variant="primary" size="sm">C’est bien la même fiche</Button>
        <Button variant="quiet" size="sm">Choisir une autre fiche</Button>
      </div>

      <p className="f-help" style={{ margin: 0 }}>
        En attendant, le rapport est marqué «&nbsp;à vérifier&nbsp;» — jamais des zéros inventés.
      </p>
    </div>
  )
}
